import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconCloseLight } from "../../../asserts/imgs/chart/fubon/close_24px_rounded_light.svg";
import common from "../../../asserts/js/common";

export const VE = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [period, setPeriod] = useState(14);
  const [period2, setPeriod2] = useState(6);
  const [volume, setVolume] = useState("808080");
  const [color, setColor] = useState("FFB0B0");
  const [color2, setColor2] = useState("449999");
  const [thickness, setThickness] = useState(2);
  const [style, setStyle] = useState("s");
  const [showTracker, setShowTracker] = useState(true);
  const [height, setHeight] = useState("1");
  const [value, setValue] = useState(period + "," + period2 + "%");

  const [localChartSetting, setLocalChartSetting] = useState(null)

  useEffect(() => {
    let localSetting = common.getlocalChartStorage();

    if (localSetting)
      setLocalChartSetting(localSetting.VE_Option)
  }, []);

  useEffect(() => {
    if (localChartSetting) {
      try {
        const VE = localChartSetting.option;

        setValue(VE.period + "," + VE.p + "%");
        props.onTAValueChange({
          ta: "VE",
          name: `${t("chart5.TA.VE")} (VE)`,
          option: {
            period: VE.period,
            p: VE.p,
            volume: VE.volume,
            color: VE.color,
            color2: VE.color2,
            thickness: VE.thickness,
            style: VE.style,
            showTracker: VE.showTracker,
            height: VE.height,
          },
          value: localChartSetting.value,
        });
      } catch { }
    }
  }, [localChartSetting]);

  useEffect(() => {
    const VE = props.localChartSetting.VE_Option.option;

    setPeriod(parseInt(VE.period) || period);
    setPeriod2(parseInt(VE.p) || period2);
    setVolume(VE.volume);
    setColor(VE.color);
    setColor2(VE.color2);
    setThickness(parseInt(VE.thickness) || thickness);
    setStyle(VE.style);
    setShowTracker(VE.showTracker);
    setHeight(VE.height);

  }, [props.localChartSetting]);

  useEffect(() => {
    setValue(period + "," + period2 + "%");
    props.onTAValueChange({
      ta: "VE",
      name: `${t("chart5.TA.VE")} (VE)`,
      option: {
        period: period,
        p: period2,
        volume: volume,
        color: color,
        color2: color2,
        thickness: thickness,
        style: style,
        showTracker: showTracker,
        height: height,
      },
      value: value,
    });
  }, [
    period,
    period2,
    volume,
    color,
    color2,
    thickness,
    style,
    showTracker,
    height,
  ]);

  useEffect(() => {
    setTAColor();
  }, [props.selectedColor]);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    const VE = props.localChartSetting.VE_Option.option;

    setPeriod(parseInt(VE.period) || period);
    setPeriod2(parseInt(VE.p) || period2);
    setVolume(VE.volume);
    setColor(VE.color);
    setColor2(VE.color2);
    setThickness(parseInt(VE.thickness) || thickness);
    setStyle(VE.style);
    setShowTracker(VE.showTracker);
    setHeight(VE.height);
  }, [props.isReset]);

  const resetALL = () => {
    setPeriod(14);
    setPeriod2(6);
    setVolume("808080");
    setColor("AA2211");
    setColor2("449999");
    setThickness(2);
    setStyle("s");
    setShowTracker(true);
    setHeight("1");
  };

  const onResetClick = () => {
    const answer = window.confirm(t("chart5.alertMsg"));
    if (answer) {
      setIsOpen(true);
      resetALL();
    } else {
      setIsOpen(true);
    }
  };

  const openOptionBox = (e) => {
    try {
      if (
        e.target.className.replace(" focus-within", "") ===
        "menusubitem msiaction techicalindicator" ||
        e.target.className.replace(" focus-within", "") === "span" ||
        e.target.className.replace(" focus-within", "") === "optboxarrow" ||
        e.target.className.replace(" focus-within", "") === "msiicon"
      ) {
        if (e.target.className.replace(" focus-within", "") !== "b2dbtn") {
          if (isOpen) setIsOpen(false);
          else setIsOpen(true);
        }
      }
    } catch (err) { }
  };

  // id: string
  const removeTA = (id) => {
    props.removeTA(id);
  };

  // e: any, type: string
  const onPeriodChange = (e, type) => {
    if (type === "p1") setPeriod(e.target.value);
    else setPeriod2(e.target.value);
  };

  const onThicknessChange = (e) => {
    setThickness(e.target.value);
  };

  const onStyleChange = (e) => {
    setStyle(e.target.value);
  };

  const onHeightChange = (e) => {
    setHeight(e.target.value);
  };

  const onShowTracker = () => {
    if (showTracker) setShowTracker(false);
    else setShowTracker(true);
  };

  const setTAColor = () => {
    switch (props.source) {
      case "VE-Volume":
        setVolume(props.selectedColor);
        break;
      case "VE-C1":
        setColor(props.selectedColor);
        break;
      case "VE-C2":
        setColor2(props.selectedColor);
        break;
    }
  };

  // color: string, type: any, title: any
  const onColorClick = (color, type, title) => {
    props.onColorClick(color, type, title);
  };

  const onKeyDown = (evt) => {
    if (evt.key === "-") evt.preventDefault();
  };

  return (
    <div
      className="menusubitem msiaction techicalindicator"
      id="msi-ta"
      onClick={(e) => openOptionBox(e)}
    >
      {/* <div className="msiicon" onClick={() => removeTA("VE")}></div> */}
      <div className="box-container">
        <span className="span">
          {t("chart5.TA.VE")} (VE) {value}
        </span>
        <IconCloseLight className="close-icon" onClick={() => removeTA("VE")} />
      </div>
      <div
        className="optboxarrow"
        style={isOpen ? { transform: "rotate(180deg)" } : {}}
        onClick={(e) => openOptionBox(e)}
      ></div>
      <div
        className="b2dbtn"
        style={isOpen ? { display: "flex" } : {}}
        title="スタイル設定を初期設定に戻す"
        onClick={onResetClick}
      ></div>
      <div className="msi-optbox" style={isOpen ? {} : { display: "none" }}>
        <div className="floatmsibox">
          <div className="menusubitem " id="msi-ta-VE">
            <div className="taparamlbl">{t("chart5.period")}</div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-VE-mid-period0"
                type="number"
                step="1"
                min="1"
                value={period}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onPeriodChange(e, "p1")}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>

          <div className="menusubitem" id="msi-ta-VE">
            <div className="taparamlbl">{t("chart5.vol2")}</div>
            <button
              id="msi-ta-VE-v-color"
              className="taparam colorpicker"
              value={volume}
              data-colorpickerdialogtitle="Volume"
              style={{ backgroundColor: "#" + volume }}
              onClick={() =>
                onColorClick(volume, "VE-Volume", t("chart5.vol2"))
              }
            ></button>
          </div>
        </div>

        <div className="menusubitem " id="msi-ta-VE">
          <div className="flexbox">
            <div className="taparamlbl">%</div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-VE-p1-period0"
                type="number"
                step="1"
                min="1"
                value={period2}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onPeriodChange(e, "p2")}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>
          <div className="menusubitem stylebox ">
            <div className="styleboxlbl">+P</div>
            <button
              id="msi-ta-VE-p1-color0"
              className="colorpicker"
              value={color}
              data-colorpickerdialogtitle="+P"
              style={{ backgroundColor: "#" + color }}
              onClick={() => onColorClick(color, "VE-C1", "+P")}
            ></button>

            <div className="styleboxlbl">-P</div>
            <button
              id="msi-ta-VE-p1-color1"
              className="colorpicker"
              value={color2}
              data-colorpickerdialogtitle="-P"
              style={{ backgroundColor: "#" + color2 }}
              onClick={() => onColorClick(color2, "VE-C2", "-P")}
            ></button>

            <div className="inputbox">
              <input
                id="msi-ta-UI-p0-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e)}
              />
            </div>
            <div className="selectbox" onChange={(e) => onStyleChange(e)}>
              <select id="msi-ta-UI-p0-style" value={style}>
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-UI-p0-showtracker"
                className={
                  showTracker ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={onShowTracker}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>

        <div className="menusubitem" id="msi-ta-UI">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.displayScreenSize")}</div>
            <div className="selectbox taparam">
              <select
                id="msi-ta-UI-ps-h"
                defaultValue="1"
                onChange={(e) => onHeightChange(e)}
                value={height}
              >
                <option value="2">{t("chart5.large")}</option>
                <option value="1">{t("chart5.normal")}</option>
                <option value="0">{t("chart5.small")}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
